class ScreenSize {
  static MOBILE_LG = 743
}

module.exports = ScreenSize
